import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Container,
  CssBaseline,
  TextField,
  Button,
  Grid,
  Typography,
  Box,
  MenuItem,
  Select,
  FormControl,
  InputLabel
} from "@mui/material";
import appLogo from "../../images/website-images/logos/app-logo.png";
import closeIcon from "../../images/website-images/icons/close-icon.png";

import { sendContactEmail } from "../../common/FunctionCalls";

const ContactUs = () => {
  const navigate = useNavigate();

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [topic, setTopic] = useState("");
  const [message, setMessage] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {

       await sendContactEmail(name, email, topic, message); 
      setSubmitted(true);
      
      console.log("sent email successfully:"+submitted);

    } catch (err) {
      alert("Error sending message. Please try sending the message again");
      console.error("Submission error", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container component="main" maxWidth="xs" sx={{ display: 'flex', justifyContent: 'center', marginTop:'40px' }}>
      <CssBaseline />
      <Box
        sx={{
          border: "1px solid #e0e0e0",
          borderRadius: "12px",
          boxShadow: "3px 3px 12px #bfbfbf",
          paddingTop: 4,
          paddingBottom: 4,
          paddingLeft: { xs: 4, sm: 8 },
          paddingRight: { xs: 4, sm: 8 },
          backgroundColor: "#fff",
          minWidth: { sm: '550px' },
        }}
      >
        <Box position="absolute" top={10} right={10} zIndex={10}>
          <a href="/">
            <img src={closeIcon} style={{ height: "30px" }} alt="close" />
          </a>
        </Box>

        <Box textAlign="center" pb={1}>
          <img
            src={appLogo}
            alt="App Logo"
            style={{ height: 85, cursor: "pointer" }}
            onClick={() => navigate("/")}
          />
          <Typography component="h1" variant="h6" fontWeight="600" mt={2}>
            Contact Us
          </Typography>
          <Typography variant="body2" sx={{ mt: 1 }}>
            We'd love to hear from you. Fill out the form and we'll respond as soon as possible.
          </Typography>
        </Box>

        {submitted ? (
          <Box textAlign="center" mt={3}>
            <Typography variant="h6" color="green">Message Sent</Typography>
            <Typography variant="body1">Thank you for contacting us!</Typography>
          </Box>
        ) : (
          <form onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  label="Full Name"
                  fullWidth
                  required
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  label="Email Address"
                  fullWidth
                  required
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </Grid>
              <Grid item xs={12}>
                <FormControl fullWidth required>
                  <InputLabel>Topic</InputLabel>
                  <Select
                    value={topic}
                    onChange={(e) => setTopic(e.target.value)}
                    label="Topic"
                  >
                    <MenuItem value="Technical Support">Technical Support</MenuItem>
                    <MenuItem value="Account Access/Login Issues">Account Access/Login Issues</MenuItem>
                    <MenuItem value="Billing & Payments">Billing & Payments</MenuItem>
                    <MenuItem value="Cancel or Pause Subscription">Cancel or Pause Subscription</MenuItem>
                    <MenuItem value="Upgrade/Downgrade Plan">Upgrade/Downgrade Plan</MenuItem>
                    <MenuItem value="Product Questions">Product Questions</MenuItem>
                    <MenuItem value="Feature Request">Feature Request</MenuItem>
                    <MenuItem value="Bug Report">Bug Report</MenuItem>
                    <MenuItem value="Integration Help">Integration Help</MenuItem>
                    <MenuItem value="Training & Onboarding">Training & Onboarding</MenuItem>
                    <MenuItem value="Demo Request">Demo Request</MenuItem>
                    <MenuItem value="Sales or Pricing Inquiry">Sales or Pricing Inquiry</MenuItem>
                    <MenuItem value="Partnership Opportunities">Partnership Opportunities</MenuItem>
                    <MenuItem value="Data Privacy or Security Inquiry">Data Privacy or Security Inquiry</MenuItem>
                    <MenuItem value="Other">Other</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  label="Message"
                  fullWidth
                  required
                  multiline
                  rows={8}
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                />
              </Grid>
            </Grid>
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{
                mt: 3,
                backgroundColor: "#635bff",
                fontWeight: "bold",
                textTransform: "none",
                fontSize: "18px",
              }}
              disabled={loading}
            >
              {loading ? "Sending..." : "Send Message"}
            </Button>
          </form>
        )}
      </Box>
    </Container>
  );
};

export default ContactUs;
